import {
  Slider,
  SliderFilledTrack,
  SliderMark,
  SliderThumb,
  SliderTrack,
} from '@chakra-ui/react';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';

export interface SliderInputMark {
  label: string;
  value: number;
}

export interface SliderInputProps {
  min?: number;
  max?: number;
  defaultValue?: number;
  step?: number;
  value: number;
  onChange: (value: number) => void;
  marks?: SliderInputMark[];
}

const SliderInput: FC<SliderInputProps> = ({
  min,
  max,
  defaultValue,
  step,
  marks,
  value,
  onChange,
}) => {
  return (
    <Slider
      min={min}
      max={max}
      defaultValue={defaultValue}
      step={step}
      value={value}
      onChange={onChange}
    >
      <SliderTrack bgColor={Color.Shade600} h="6px" borderRadius="4px">
        <SliderFilledTrack bgColor={Color.Primary500} />
      </SliderTrack>
      <SliderThumb bgColor="#000" w="20px" h="20px" />
      {marks?.map((mark, index) => {
        return (
          <SliderMark key={index} value={mark.value} mt="15px" ml="-5px">
            {mark.label}
          </SliderMark>
        );
      })}
    </Slider>
  );
};

export default SliderInput;
